import { Currency } from '~/types/currency'

export const CURRENCY_SYMBOL: { [key in Currency]: string } = {
  [Currency.EUR]: '€',
  [Currency.AED]: 'د.إ',
  [Currency.AMD]: '֏',
  [Currency.ARS]: 'ARS$',
  [Currency.AUD]: 'A$',
  [Currency.BGN]: 'лв',
  [Currency.BRL]: 'R$',
  [Currency.CAD]: 'C$',
  [Currency.CHF]: 'CHF',
  [Currency.CLP]: 'CLP$',
  [Currency.CNY]: 'CN¥',
  [Currency.CZK]: 'Kč',
  [Currency.DKK]: 'DKK',
  [Currency.GBP]: '£',
  [Currency.HKD]: 'HK$',
  [Currency.HUF]: 'Ft',
  [Currency.ILS]: '₪',
  [Currency.INR]: '₹',
  [Currency.JPY]: 'JP¥',
  [Currency.KRW]: '₩',
  [Currency.MAD]: 'د.م.',
  [Currency.MOP]: 'MOP$',
  [Currency.MXN]: 'MX$',
  [Currency.PKR]: '₨',
  [Currency.PLN]: 'zł',
  [Currency.RON]: 'lei',
  [Currency.SEK]: 'SEK',
  [Currency.TND]: 'د.ت',
  [Currency.TWD]: 'NT$',
  [Currency.USD]: 'US$',
  [Currency.UYU]: '$U'
}
